import { useState, useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
// child
import Input from "../../ChildComponents/Input";
import BrandButton from "../../ChildComponents/BrandButton";
import ImageUpload from "../../ChildComponents/ImageUpload";
import Select from "../../ChildComponents/Select";

// validationSchema
import { Rolechema } from "../validation/roleValidation";

// api
import {
  useCreateCategory,
  useUpdateCategory,
  useGetCategory,
} from "../../store/api/categoryApi";

function RoleForm({ data, editId, onSuccessCreated }) {
  const updateCategory = useUpdateCategory(editId?._id);
  // init
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
  } = useForm({
    resolver: yupResolver(Rolechema),
  });

  const getCategory = useGetCategory();
  const {
    data: categoryData,
    isLoading: isRoleLoading,
    error: roleError,
    refetch,
  } = useQuery({ queryKey: ["category"], queryFn: getCategory });

  const transformedCategory = categoryData?.categorys?.map((i) => ({
    label: i.name,
    value: i._id,
  }));

  useEffect(() => {
    if (editId) {
      reset({
        name: editId?.name || "",
        categorySlug: editId?.categorySlug || "",
        parentCategory: editId?.parentCategory || "",
        categoryImage: editId?.categoryImage || "",
      });
      setEdited(true);
    }
  }, [editId, reset]);

  const createCategory = useCreateCategory();
  const navData = data.data;

  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(editId ? true : false);

  const mutation = useMutation({
    mutationFn: (data) => {
      return editId ? updateCategory(data) : createCategory(data);
    },
    onSuccess: (data) => {
      setLoading(false);
      toast.success("Creatred Successfuly");
      reset();
      onSuccessCreated(1);
      refetch();
    },
    onError: (error) => {
      toast.error(error.message);
      setLoading(false);
    },
  });

  const onSubmit = (formData) => {
    setLoading(true);

    try {
      mutation.mutate({
        name: formData?.name,
        categorySlug: formData?.categorySlug,
        parentCategory: formData?.parentCategory?.value || "",
        categoryImage: formData?.categoryImage,
      });
    } catch (error) {
      setLoading(false);
      console.error("Caught error in handleSubmit:", error.message);
      toast.error(error.message);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} action="">
        <div className="row">
          <div className="col-sm-9">
            <div className="row">
              <div className="col-sm-4">
                <Input
                  icon="title"
                  {...register("name")}
                  error={errors.name?.message}
                  type="text"
                  placeholder={`Internation`}
                  label="Category Name"
                />
              </div>
              <div className="col-sm-4">
                <Input
                  icon="title"
                  {...register("categorySlug")}
                  error={errors.name?.message}
                  type="text"
                  placeholder={`internation`}
                  label="Category Slug"
                />
              </div>
              <div className="col-sm-4">
                <Controller
                  name="parentCategory"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isClearable
                      options={transformedCategory}
                      placeholder="Select Parent Category"
                      label="Select Parent Category"
                    />
                  )}
                />
              </div>
              <BrandButton
                type="submit"
                // title={`${!loading ? "Login" : "Loading...."}`}
                title={`Save Change`}
                className="my-5"
              />
            </div>
          </div>
          {/* <div className="col-sm-3 mt-4">
            <Controller
              name="categoryImage"
              control={control}
              defaultValue={null}
              render={({ field }) => (
                <ImageUpload
                  label="Category Image"
                  name="image"
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </div> */}
        </div>
      </form>
    </div>
  );
}

export default RoleForm;
